// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22R1z","right":"styles_right__MjXNe"};